import {FunctionComponent} from 'react';

interface ElementProps {
  title: string;
}

const PanelTitle: FunctionComponent<ElementProps> = ({title}) => {
  return (
    <>
      <h2 className="mb-3.5 px-6 text-sm font-medium text-grey">{title}</h2>
    </>
  );
};

export default PanelTitle;
